const buildEprototypes = () => {
  if (!Array.prototype.Emap) {
    Array.prototype.Emap = function (callback) {
      const innerArray = this;

      const Ecallback = (element, index, array) => {
        const isLast = innerArray.length === index + 1;

        return callback(element, index, array, isLast);
      };

      const result = innerArray.map(Ecallback);
      return result;
    };
  }
  else {
    throw new Error("emap already exists");
  }
};

export default buildEprototypes;
